import React, { ReactNode } from 'react';
import { Footer } from '../footer/footer';
import { PageHeader } from '../page-header/page-header';
import { notNil } from '../../core/helpers/is-nil';
import { Spacer } from '../spacer/spacer';
import useResetPageScroll from '../../core/hooks/use-reset-page-scroll';
import styles from './default-page-layout.module.scss';

type BasePageHeader = {
  type: 'base';
  content: ReactNode;
  imgUrl?: string;
};

type CustomPageHeader = {
  type: 'custom';
  content: ReactNode;
};

const isBasePageHeader = (pageHeader: BasePageHeader | CustomPageHeader): pageHeader is BasePageHeader => {
  return pageHeader.type === 'base';
};

type Props = {
  appHeader: ReactNode;
  pageHeader?: BasePageHeader | CustomPageHeader;
  children: ReactNode;
};

export const DefaultPageLayout: React.FC<Props> = ({ appHeader, pageHeader, children }) => {
  useResetPageScroll();
  return (
    <div className={styles.root}>
      {appHeader}
      <div className={styles.content}>
        {notNil(pageHeader) ? (
          isBasePageHeader(pageHeader) ? (
            <PageHeader bgSrc={pageHeader.imgUrl}>{pageHeader.content}</PageHeader>
          ) : (
            pageHeader.content
          )
        ) : (
          <Spacer size="09" sizeXs="08" />
        )}
        {children}
      </div>
      <Footer />
    </div>
  );
};
